import { FLAGS, useFlag } from '@iheartjane/feature-flags';
import { formatFeaturedRow } from '@iheartjane/menu';
import { useParams } from 'react-router';

import { formatFeaturedCategory } from '@jane/search/util';
import type { Store } from '@jane/shared/types';

interface RowContext {
  featuredCategory?: string;
  featuredFilter: string;
  featuredTitle: string;
  isJaneDefined: boolean;
  rowId?: number;
  slug?: string;
}

export const useRowContext = (store: Store): RowContext => {
  const {
    rowId: rowIdParam,
    slug,
    featuredCategory,
  } = useParams<{
    featuredCategory?: string;
    rowId?: string;
    slug?: string;
  }>();
  const useMenuRowType = useFlag(FLAGS.cnMenuRowTypeFe);

  if (rowIdParam) {
    const rowId = Number(rowIdParam);
    const { featuredTitle, featuredFilter, isJaneDefined } = formatFeaturedRow(
      Number(store.id),
      store.custom_row_settings,
      rowId
    );
    return { rowId, slug, featuredTitle, featuredFilter, isJaneDefined };
  }

  const { featuredTitle, featuredFilter, isJaneDefined } =
    formatFeaturedCategory(store, featuredCategory, useMenuRowType);

  return { featuredCategory, featuredTitle, featuredFilter, isJaneDefined };
};
